//TODO: replace with ht.toggleClasses
//twistys expand all
$('body').on('click', '.twistExpand', function () {
  $('dl.twisty > dt:not(.lite), dl.twisty > dd').removeClass('twistClosed');
  return false;
});
